import { useSetAtom } from 'jotai'
import React from 'react'

import { HStack } from '~/components/elements/HStack'
import {
  TooltipButton,
  type TooltipButtonProps,
} from '~/components/elements/TooltipButton'
import { type Brand } from '~/hooks/useSurveyForSettingsQuery'

import { dialogInfoAtom } from '../atoms'

export type CommandsCellProps = {
  dataItem: Brand
}

export const CommandsCell = ({ dataItem: brand }: CommandsCellProps) => {
  const setDialogInfo = useSetAtom(dialogInfoAtom)
  const handleDeleteButtonClick = React.useCallback<
    EH<TooltipButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ dialogType: 'delete', brand })
  }, [brand, setDialogInfo])

  return (
    <td>
      <HStack backgroundColor="transparent" justify="center" spacing={0}>
        <TooltipButton
          fillMode="flat"
          icon="delete"
          title="Delete"
          onClick={handleDeleteButtonClick}
        />
      </HStack>
    </td>
  )
}
